/**
 * SuperAdmin Configuration Endpoints
 * SUPERADMIN: Program configuration APIs (About Program, Regions, etc.)
 */

export const ABOUT_PROGRAM_ENDPOINTS = {
  get: 'superadmin/about-program',
  update: 'superadmin/about-program/update',
};

export const SUPERADMIN_REGIONS_ENDPOINTS = {
  list: 'superadmin/regions',
  create: 'superadmin/regions/create',
  update: 'superadmin/regions/update',
  delete: 'superadmin/regions/delete',
};

export const GEO_GROUPS_ENDPOINTS = {
  list: 'superadmin/geo-groups',
  create: 'superadmin/geo-groups/create',
  update: 'superadmin/geo-groups/update',
  delete: 'superadmin/geo-groups/delete',
};

export const USER_TYPE_ENDPOINTS = {
  list: 'superadmin/user-types',
  create: 'superadmin/user-types/create',
  update: 'superadmin/user-types/update',
  delete: 'superadmin/user-types/delete',
};

export const USER_GROUPS_ENDPOINTS = {
  list: 'superadmin/user-groups',
  create: 'superadmin/user-groups/create',
  update: 'superadmin/user-groups/update',
  delete: 'superadmin/user-groups/delete',
};

export const BRAND_SKU_ENDPOINTS = {
  portfolios: {
    list: 'brands/get-portfolios',
    catalog: 'brands/portfolio-catalog',
    create: 'brands/create-portfolio',
    update: 'brands/update-portfolio',
    delete: 'brands/disable-portfolio',
  },
  categories: {
    list: 'brands/get-brand-categories',
    create: 'brands/create-brand-category',
    update: 'brands/update-brand-category',
    delete: 'brands/delete-brand-category',
  },
  brands: {
    list: 'brands/get-brand',
    create: 'brands/create-brand',
    update: 'brands/update-brand',
    delete: 'brands/delete-brand',
    upload: 'brands/upload-brands',
    uploadFields: 'brands/brand-upload-fields',
  },
};

export const COMMUNICATION_ENDPOINTS = {
  list: 'superadmin/communication',
  create: 'superadmin/communication/create',
  update: 'superadmin/communication/update',
  delete: 'superadmin/communication/delete',
};

export const SECURITY_ENDPOINTS = {
  list: 'superadmin/security',
  update: 'superadmin/security/update',
};

export const REPORTS_ENDPOINTS = {
  list: 'superadmin/reports',
  generate: 'superadmin/reports/generate',
  download: 'superadmin/reports/download',
};
